module.exports = __webpack_public_path__ + "static/media/expert (6).b21e915d.png";